import { Box, Flex, Spinner, Text } from '@chakra-ui/react';

import { Accordion, Badge } from '@morressier/alembic';

import AccordionContent from './AccordionContent';
import { useQuery } from '@tanstack/react-query';
import { fetchVersionLogV2 } from 'src/api/queries';
import dateFormat from 'dateformat';

const VersionHistoryLog: React.FC<{ submissionId: string }> = ({
  submissionId
}) => {
  const { data: VersionHistoryLogDataV2, isLoading } = useQuery({
    queryKey: ['version-log', { submissionId }],
    queryFn: () => fetchVersionLogV2(submissionId),
    retry: 0
  });
  const rounds = [...(VersionHistoryLogDataV2?.rounds ?? [])].reverse();
  return (
    <Flex flexDirection="column" gap={4} width={'96%'} marginRight={'auto'}>
      {isLoading ? (
        <Spinner />
      ) : (
        <>
          {rounds.map((round, index) => {
            const isTransferred = round.decision === 'Transfer Offered';
            return (
              <Flex
                key={`${round.manuscriptId}-${index}`}
                direction="column"
                gap={2}
              >
                {isTransferred && (
                  <Flex padding={3} justifyContent={'flex-end'}>
                    <Badge variant={'neutral'} size="context">
                      {'Transferred'}
                    </Badge>
                  </Flex>
                )}

                <Accordion
                  data-testId="submission-version-log"
                  chakraAccordionProps={{
                    allowMultiple: true,
                    defaultIndex: index === 0 ? [0] : [],
                    style: {
                      display: 'flex',
                      flexDirection: 'column',
                      width: '100%'
                    }
                  }}
                  accordionItemProps={{
                    marginBottom: 1,
                    width: '100%'
                  }}
                  items={[
                    {
                      title: (
                        <Flex gap={2}>
                          <Text textStyle="headingItem">
                            {`${round.manuscriptId} | `}{' '}
                            {round.round === 1
                              ? 'Original Submission'
                              : `Revision ${round.round - 1}`}
                            {' ('}
                            {dateFormat(round.dateEntered, 'mmm d, yyyy')}
                            {' to '}
                            {round.dateCompleted !== 'Ongoing'
                              ? dateFormat(round.dateCompleted, 'mmm d, yyyy')
                              : 'Ongoing'}{' '}
                            {')'}
                          </Text>

                          {round.isCurrentRound && (
                            <Badge variant="neutral" padding={2} size="context">
                              Current Round
                            </Badge>
                          )}
                        </Flex>
                      ),
                      subtitle: (
                        <Box>
                          Decision:{' '}
                          {round.decision === 'Decision Pending' ? (
                            <Text as="span">No decision made yet</Text>
                          ) : (
                            <Text as="span" textTransform={'capitalize'}>
                              {round.decision}
                            </Text>
                          )}
                        </Box>
                      ),
                      content: (
                        <AccordionContent
                          peerReviewInfo={round.peerReviewInfo}
                          fileset={round.fileSet}
                          submissionId={submissionId}
                        />
                      )
                    }
                  ]}
                />
              </Flex>
            );
          })}
        </>
      )}
    </Flex>
  );
};

export default VersionHistoryLog;
